import { render, staticRenderFns } from "./NoticeCreateModal.vue?vue&type=template&id=04f9e921&"
import script from "./NoticeCreateModal.vue?vue&type=script&lang=js&"
export * from "./NoticeCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports